import { render, staticRenderFns } from "./addHsct.vue?vue&type=template&id=2062eb87"
import script from "./addHsct.vue?vue&type=script&lang=js"
export * from "./addHsct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports